module.exports = __webpack_public_path__ + "static/media/nav-icon-survey-list-inactive.809c348b.svg";